import { buttonTheme as Button } from './button.theme';
import { containerTheme as Container } from './container.theme';
import { inputTheme as Input } from './input.theme';
import { linkTheme as Link } from './link.theme';
import { modalTheme as Modal } from './modal.theme';
import { textTheme as Text } from './text.theme';
import { headingTheme as Heading } from './heading.theme';

import { timeStatTheme as TimeStat } from 'components';

export const components = {
  Button,
  Container,
  Heading,
  Text,
  Modal,
  TimeStat,
  Link,
  Input,
};
